import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginTop: theme.spacing(2)
    },
    navigationButton: {
        minWidth: 40,
        minHeight: 40,
        padding: theme.spacing(.75),
        border: `1px solid ${theme.palette.tertiary.main}`,
        borderRadius: theme.shape.borderRadius,
        borderColor: theme.palette.tertiary.main,
        color: theme.palette.tertiary.main,
        '&:hover': {
            borderColor: theme.palette.tertiary.dark,
            backgroundColor: 'rgba(22, 114, 187, 0.06)'
        },
        '&:first-child': {
            justifySelf: 'start'
        },
        '&:last-child': {
            justifySelf: 'end'
        }
    },
    pageLabel: {
        color: theme.palette.text.secondary,
        fontSize: '0.875rem',
        whiteSpace: 'nowrap'
    }
}));

export default function MobilePagination({ page, count, rowsPerPage, onPageChange }) {
    const classes = useStyles();
    const totalPages = Math.max(1, Math.ceil(count / rowsPerPage));
    const currentPage = Math.min(Math.max(page, 0), totalPages - 1);

    return (
        <div className={classes.root} aria-label="Paginação">
            <IconButton
                className={classes.navigationButton}
                disabled={currentPage === 0}
                aria-label="Página anterior"
                onClick={event => onPageChange(event, currentPage - 1)}>
                <ArrowBack />
            </IconButton>
            <span className={classes.pageLabel}>
                Página {currentPage + 1} de {totalPages}
            </span>
            <IconButton
                className={classes.navigationButton}
                disabled={currentPage >= totalPages - 1}
                aria-label="Próxima página"
                onClick={event => onPageChange(event, currentPage + 1)}>
                <ArrowForward />
            </IconButton>
        </div>
    );
}

MobilePagination.propTypes = {
    page: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired
};
